import { render, staticRenderFns } from "./twitter_prize_table.vue?vue&type=template&id=11e4f2ba&scoped=true"
import script from "./twitter_prize_table.vue?vue&type=script&lang=ts"
export * from "./twitter_prize_table.vue?vue&type=script&lang=ts"
import style0 from "./twitter_prize_table.vue?vue&type=style&index=0&id=11e4f2ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e4f2ba",
  null
  
)

export default component.exports